namespace Seac.Pages {
	export class SessionStateUtility {
		/** All'apertura della pagina salvo l'impresa del cookie in questa proprietà, in modo da poterla verificare al moment dell'invio dei dati */
		private _impresaIdOnOpen: string;

		public init(): void {
			this._impresaIdOnOpen = Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_IMPRESA_ID);
		}

		/** Verifico che l'impresa corrente (salvata nel cookie) sia la stessa di quella salvata all'apertura della pagina */
		public checkImpresaOnPost(): boolean {
			if (this._impresaIdOnOpen && this._impresaIdOnOpen != Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_IMPRESA_ID)) {
				// Se l'impresa è stata cambiata dopo l'apertura della pagina (es. è stata aperta una nuova scheda e selezionata un'altra impresa) emetto un errore
				Seac.Commons.notificationManager.addSimpleNotification(Seac.Resources.Common.impresa_cambiata_dopo_apertura_pagina, Seac.Commons.NotificationType.error, true);
				return false;
			}
			return true;
		}
	}

	export const sessionStateUtility: SessionStateUtility = new SessionStateUtility();
	jQuery(document).ready(() => {
		sessionStateUtility.init();
	});
}
